import { takeLatest } from "redux-saga/effects";
import { approvedStatusDeviceApi } from "store/api/LoginApi";
import { APPROVED_STATUS_DEVICE_ACTION } from "../../actions/LoginPageAction/actionTypes";

function* changeStatusApprovedDevice(action) {
	const { data, onSuccess } = action.params;
	const res = yield approvedStatusDeviceApi(data);
	try {
		if (res?.code === 0) {
			onSuccess();
		}
	} catch (e) {
		console.log(e);
	}
}

function* approvedStatusDevice() {
	yield takeLatest(APPROVED_STATUS_DEVICE_ACTION, changeStatusApprovedDevice);
}

export default approvedStatusDevice;
